import React from 'react';
import '../../styles/form.css';

export default function FormItem({
    label,
    name,
    type = "text",
    value,
    onChange,
    placeholder = "",
    error = "",
    required = false,
    className = "",
    children,
    ...props
}) {
    const inputId = `form-${name}`;

    return (
        <div className={`form-item ${className} ${error ? "has-error" : ""}`} {...props}>

            {label && (
                <label htmlFor={name} className="form-label">
                    {label}
                    {required && <span className="required">*</span>}
                </label>
            )}

            {children ? (
                children
            ) : (
                type === "textarea" ? (
                    <textarea
                        id={inputId}
                        name={name}
                        value={value}
                        rows={5}
                        onChange={onChange}
                        placeholder={placeholder}
                        className={`form-input-textarea ${error ? "input-error" : ""}`}
                    />
                ) : (
                <input
                    id={inputId}
                        name={name}
                        type={type}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        className={`form-input ${error ? "input-error" : ""}`}
                    />
                )
            )}

            {error && <p className="form-error">{error}</p>}
        </div>
    );
}